import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ViewChangeEvent } from 'src/app/models/events/view-change-event';
import { ViewType } from 'src/app/models/server/enums/view-type';
import { View } from 'src/app/models/server/view';

@Injectable({
    providedIn: 'root',
})
export class ViewsStateService {
    private onViewsSelectionChange = new BehaviorSubject<ViewChangeEvent>(null);

    /**
     * Liste des vues de type bannettes accessibles par l'utilisateur connecté.
     */
    public boxViews: View[] = [];

    /**
     * Liste des vues de type workflow  accessibles par l'utilisateur connecté.
     */
    public workflowViews: View[] = [];

    /**
     * Liste des vues de type Archive bannettes ou archive workflow accessibles par l'utilisateur connecté.
     */
    public archivingViews: View[] = [];

    /**
     * Emet un événement lorsqu'une vue est sélectionnée.
     */
    public get onViewsSelectionChange$() {
        return this.onViewsSelectionChange.asObservable();
    }

    /**
     * Retourne la vue selectionnée.
     * @returns La vue selectionnée.
     */
    public getSelectedView(): View {
        return !!this.onViewsSelectionChange.value && !!this.onViewsSelectionChange.value.currentView ? this.onViewsSelectionChange.value.currentView : null;
    }

    /**
     * Spécifie la vue selectionnée.
     * @param view: La vue selectionnée.
     * @param force indiquant si un evenement doit être émis même si la vue selectionnée est lma même que la vue courante.
     */
    public setSelectedView(view: View, force: boolean = false) {
        if (this.getSelectedView()?.id !== view?.id || force === true) {
            let viewChangeEvent: ViewChangeEvent;

            if (this.onViewsSelectionChange.value) {
                viewChangeEvent = this.onViewsSelectionChange.value;
            } else {
                viewChangeEvent = new ViewChangeEvent();
            }

            viewChangeEvent.precedentView = viewChangeEvent.currentView;
            viewChangeEvent.currentView = view;
            this.onViewsSelectionChange.next(viewChangeEvent);
        }
    }

    public selectLinkedView(view: View) {
        if (view.isArchive) {
            // Charge la vue 'active'
            if (view.viewType === ViewType.Box) {
                const linkedView = this.boxViews.find((x) => x.id === view.parentId);
                this.setSelectedView(linkedView);
            } else {
                const linkedView = this.workflowViews.find((x) => x.id === view.parentId);
                this.setSelectedView(linkedView);
            }
        } else {
            // Charge la vue 'archive'
            const linkedView = this.archivingViews.find((x) => x.parentId === view.id);
            this.setSelectedView(linkedView);
        }
    }

    public constructor() {}
}
